
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateOrdercartDtoFormGroup() {
return new FormGroup({
    notes: new FormControl<string | undefined>(undefined, [Validators.maxLength(1200)]),
})
;
}
      